module.exports = __webpack_public_path__ + "img/featuredartist (3).c19540e5.jpg";